import {Style, Fill, Stroke, Icon, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class FrontLayer extends GeoJsonLayer {

    constructor( map, settings = {}){
        settings["name"] = 'front';
        settings["dynamic_time"] = true;
        settings["api_endpt"] = "FrontJSON.php";
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        return url.toString();
    }

    getColor( feature ){
        if( this.property(feature,'type') == "HIGH" )
            return "#0000FF";
        else if( this.property(feature,'type') == "LOW" )
            return "#FF0000";
        else if( this.property(feature,'type') == "COLD" )
            return "#0000FF";
        else if( this.property(feature,'type') == "WARM" )
            return "#FF0000";
        else if( this.property(feature,'type') == "STNRY" )
            return "#00FF00";
        else if( this.property(feature,'type') == "OCFNT" )
            return "#FF00FF";
        else if( this.property(feature,'type') == "TROF" )
            return "#BBBB00";
        return "#000000";
    }

    getIcon( feature ){
        let params = "";
        if( this.property(feature,'type') == "HIGH" )
            params = params + "code=HIGH&color=0000FF";
        else if( this.property(feature,'type') == "LOW" )
            params = params + "code=LOW&color=FF0000";
        return this.icon_path+'/wxicon.php?'+params;
    }

    getLabel( feature ){
        let str = "";
        if( this.settings['labels'] == true && 
                this.property(feature,'pressure') != undefined )
            str = this.property(feature,'pressure').toString();
        return str;
    }

    getStyle(feature, resolution ){
        let style;
        let size = 20;
        if( this.property(feature,'type') == "LOW" || 
                this.property(feature,'type') == "HIGH" ){
            style = new Style({
                    "image": new Icon({
                            "src": this.getIcon(feature),
                            "imgSize": [size,size]
                            }),
                    "text": new Text({
                            "font": "10px",
                            "fill": new Fill({
                                    "color": Library.parseHexColorToArray(this.getColor(feature), 1.),
                                    }),
                            "text": this.getLabel(feature),
                            "stroke": new Stroke({"color": "white", "width": 2 }),
                            "offsetX": 0,
                            "offsetY": 18
                            })
                    });
        }
        else if( this.property(feature,'type') == "TROF" ){
            style = new Style({
                    "stroke": new Stroke({
                            "color": Library.parseHexColorToArray(this.getColor(feature), 1.),
                            "width": 4,
                            "lineDash": [12,12],
                            }),
                    });
        }
        else if( this.property(feature,'type') == "STNRY" ){
            style = [
                new Style({
                        "stroke": new Stroke({
                                "color": Library.parseHexColorToArray("#FF0000", 1.),
                                "lineDash": [18,18],
                                "width": 4,
                                }),
                        }),
                    new Style({
                            "stroke": new Stroke({
                                    "color": Library.parseHexColorToArray("#0000FF", 1.),
                                    "lineDash": [18,18],
                                    "lineDashOffset": 18,
                                    "width": 4,
                                    }),
                            })
            ];
        }
        else {
            style = new Style({
                    "stroke": new Stroke({
                            "color": Library.parseHexColorToArray(this.getColor(feature), 1.),
                            "width": 4,
                            }),
                    });
        }

        return style;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "FRONT", this.property(feature,'type'));
        if( this.property(feature,'validTime') != undefined )
            text += this.popupData( "Valid Time", this.property(feature,'validTime') );
        if( this.property(feature,'pressure') != undefined )
            text += this.popupData( "Pressure", this.property(feature,'pressure'));
        if( this.property(feature,'strength') != undefined )
            text += this.popupData( "Strength", this.property(feature,'strength'));
        text += this.popupEnd();
        return text;
    }

    updateTime(){
        this.refresh();
    }
}